import { Moment } from 'moment';

export const dateTimeFormat = (date: Moment) => date.format('MMM DD, YYYY, [at] h:mm A');
